import { Button, Container, Divider, Group, Paper, Stack, Text, Title } from '@mantine/core';
import { IconLogout } from '@tabler/icons-react';
import { useAuth } from '../../platform/auth/AuthProvider';

export function SettingsPage() {
  const { user, signOut } = useAuth();

  return (
    <Container size="md" py="md">
      <Stack gap="xl">
        <Title order={2}>Settings</Title>

        <Paper withBorder p="lg" radius="md">
          <Stack gap="md">
            <Title order={4}>Account</Title>
            <Divider />
            <Group justify="space-between">
              <Text c="dimmed" size="sm">
                Email
              </Text>
              <Text>{user?.email ?? '—'}</Text>
            </Group>
            <Group justify="space-between">
              <Text c="dimmed" size="sm">
                User ID
              </Text>
              <Text ff="monospace" size="sm">
                {user?.uid ?? '—'}
              </Text>
            </Group>
            <Group justify="space-between">
              <Text c="dimmed" size="sm">
                Provider
              </Text>
              <Text size="sm">{user?.providerData[0]?.providerId ?? '—'}</Text>
            </Group>
          </Stack>
        </Paper>

        <Paper withBorder p="lg" radius="md">
          <Stack gap="md">
            <Title order={4}>Session</Title>
            <Divider />
            <Group>
              <Button
                variant="light"
                color="red"
                leftSection={<IconLogout size={16} />}
                onClick={() => void signOut()}
              >
                Sign out
              </Button>
            </Group>
          </Stack>
        </Paper>
      </Stack>
    </Container>
  );
}
